/* eslint-disable @next/next/no-img-element */
import React from "react";

interface EnergyLabelProps {
  energyLabel: string;
}

const EnergyLabel: React.FC<EnergyLabelProps> = ({ energyLabel }) => {
  const labelToFileMap: { [key: string]: string } = {
    A: "A.gif",
    A1: "A1.gif",
    A2: "A2.gif",
    A2010: "A2010.gif",
    A2015: "A2015.gif",
    A2020: "A2020.gif",
    B: "B.png",
    C: "C.png",
    D: "D.png",
    E: "E.png",
    F: "F.png",
    G: "G.png",
  };

  const imagePath = `/energylabels/${labelToFileMap[energyLabel]}`;
  return <img src={imagePath} alt={`Energy Label ${energyLabel}`} />;
};

export default EnergyLabel;
